module.exports = __webpack_public_path__ + "img/06.859f8af2.png";